import Box from "@mui/material/Box";
import styled from "styled-components";

export const StyledProgressStepsList = styled(Box)`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;
